import { render, staticRenderFns } from "./_footer.vue?vue&type=template&id=28674f7e&scoped=true&"
import script from "./_footer.vue?vue&type=script&lang=js&"
export * from "./_footer.vue?vue&type=script&lang=js&"
import style0 from "./_footer.vue?vue&type=style&index=0&id=28674f7e&lang=scss&scoped=true&"
import style1 from "./_footer.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28674f7e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMain } from 'vuetify/lib/components/VMain';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VIcon,VMain,VProgressLinear,VRow,VSelect})
